import React, { useEffect, useState } from "react";
import "./GroupLoansListPayments.scss";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, Typography, CircularProgress } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import CloseIcon from "@mui/icons-material/Close";
import GroupLoansTable from "../../../components/GroupLoansTable/GroupLoansTable";
import GroupLoansViewLateFees from "../GroupLoansViewLateFees/GroupLoansViewLateFees";
import GroupLoansViewPayments from "../GroupLoansViewPayments/GroupLoansViewPayments";
import GroupLoansAppliedToLoans from "../GroupLoansAppliedToLoans/GroupLoansAppliedToLoans";
import GroupLoansAppliedToLateFees from "../GroupLoansAppliedToLateFees/GroupLoansAppliedToLateFees";
import BaseDrawer from "../../../components/UI/BaseDrawer/BaseDrawer";

const GroupLoansListPayments = ({ selectedMember, setMembersListView, selectedMemberName }) => {
    const [paymentsArray, setPaymentsArray] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [loansListView, setLoansListView] = useState(null);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
    
    useEffect(()=>{
        console.log("GroupLoansListPayments------------",selectedMember)
        getListOfPayments();
    },[selectedMember]);

    const getListOfPayments = async() => {
        try {
            const response = await commonRunQuery(292, selectedMember?.loangroupmemberloan?.userid);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loansArr = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setPaymentsArray(loansArr);
              console.log("getListOfLoans_response==========",loansArr);
            } else {
                setPaymentsArray([]);
            }
        } catch (error) {
            console.log("getListOfLoans_error==========",error);
        } finally {
            setLoading(false)
        }
    }

    const columns = [
        {
            label: 'Payment Id',
            getValue: (row) => row?.loanpayments?.paymentid ?? ''
        },
        {
            label: 'Payment Amount',
            getValue: (row) => row?.loanpayments?.paymentamount  ?? '',
            align: 'right',
            amount: true
        },
        {
            label: 'Payment Date',
            getValue: (row) => row?.loanpayments?.paymentdate ?? ''
        },
        // {
        //     label: 'Product Code',
        //     getValue: (row) => row?.loanpayments?.currcode ?? ''
        // },
        {
            label: 'Loan Id',
            getValue: (row) => row?.loanpayments?.loanid ?? ''
        },
        {
            label: 'Late Fee Only',
            getValue: (row) => row?.loanpayments?.latefeesonly ?? ''
        }
    ];

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedPayment(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    const formatedRows = (row) => columns.map((column) => column.getValue(row));

    return (
        <Box>
            {
                loansListView == null && <Box className="d-flex justify-content-between">
                    <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                    className=""
                    >
                        List Of Payments - {selectedMemberName}
                    </Typography>

                    <Button
                        className="fs-size-12 paiy-blue text-white"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setMembersListView(null);
                        }}
                    >
                        Return
                    </Button>
                </Box>
            }

                {loading ? (
                    <Box
                        sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        overflow: "hidden",
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        {
                            loansListView == null && <Box className="mt-4">
                                <GroupLoansTable
                                    data={paymentsArray} 
                                    columns={columns} 
                                    title="List of Loans" 
                                    formatRow={formatedRows} 
                                    viewMenu={true}
                                    handleMenuOpen={handleMenuOpen}
                                    downloads={false}
                                    // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                                />
                            </Box>
                        }
                    </>
                )}

            { loansListView == "appliedLoans" && <GroupLoansAppliedToLoans selectedPayment={selectedPayment} setLoansListView={setLoansListView} selectedMemberName={selectedMemberName} /> }
            { loansListView == "appliedLateFees" && <GroupLoansAppliedToLateFees selectedPayment={selectedPayment} setLoansListView={setLoansListView} selectedMemberName={selectedMemberName} /> }

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem
                    onClick={() => {
                        setLoansListView('appliedLoans');
                        handleMenuClose();
                    }}
                >
                    Applied To Loans
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setLoansListView('appliedLateFees');
                        handleMenuClose();
                    }}
                >
                    Applied To Late Fees
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        // setOpenDetailsDialog(true);
                        setOpenDetailsDrawer(true);
                        handleMenuClose();
                    }}
                >
                    View Details
                </MenuItem>
            </Menu>

            <BaseDrawer
                open={openDetailsDrawer}
                handleClose={() => setOpenDetailsDrawer(false)}
                height="75vh"
                className="loanProductInfoDrawer"
                overflow="auto"
            >
                {selectedPayment && (
                    <Box>
                        <Box className="user-accounts-tab">
                            <Box className="balance-container">
                                <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                    {/* Left Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[ 
                                            { label: "Loan ID", value: selectedPayment?.loanpayments?.loanid },
                                            { label: "User ID", value: selectedPayment?.loanpayments?.userid },
                                            { label: "Payment ID", value: selectedPayment?.loanpayments?.paymentid },
                                            { label: "Payment Date", value: selectedPayment?.loanpayments?.paymentdate },
                                            { label: "Currency Code", value: selectedPayment?.loanpayments?.currcode },
                                            { label: "External Ref No", value: selectedPayment?.loanpayments?.externalrefno },
                                            { label: "Late Fees Only", value: selectedPayment?.loanpayments?.latefeesonly === "1" ? "Yes" : "No" },
                                            { label: "Lock Flag", value: selectedPayment?.loanpayments?.lockflag === "1" ? "Locked" : "Unlocked" },
                                            { label: "Last Reconcile Date", value: selectedPayment?.loanpayments?.lastreconciledate || "N/A" },
                                            { label: "Error Message", value: selectedPayment?.loanpayments?.errormsg || "N/A" }
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">{value || "N/A"}</Box>
                                            </Box>
                                        ))}
                                    </Box>

                                    {/* Right Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[ 
                                            { label: "Payment Amount", value: selectedPayment?.loanpayments?.paymentamount },
                                            { label: "Amount Applied", value: selectedPayment?.loanpayments?.amountapplied },
                                            { label: "Residual Amount", value: selectedPayment?.loanpayments?.residualamount },
                                            { label: "Principal Amount Applied", value: selectedPayment?.loanpayments?.principleamountapplied },
                                            { label: "Fees Amount Applied", value: selectedPayment?.loanpayments?.feesamountapplied },
                                            { label: "Late Fees Amount Applied", value: selectedPayment?.loanpayments?.latefeesamountapplied },
                                            { label: "Hash Payment Amount", value: selectedPayment?.loanpayments?.hashpaymentamount },
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">
                                                    {value ? Number(value).toLocaleString() : "N/A"}
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
            </BaseDrawer>

            {/* <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="sm"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Payment Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedPayment && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                        <Box minWidth="300px" flex={1}>
                                            {[ 
                                                { label: "Loan ID", value: selectedPayment?.loanpayments?.loanid },
                                                { label: "User ID", value: selectedPayment?.loanpayments?.userid },
                                                { label: "Payment ID", value: selectedPayment?.loanpayments?.paymentid },
                                                { label: "Payment Date", value: selectedPayment?.loanpayments?.paymentdate },
                                                { label: "Currency Code", value: selectedPayment?.loanpayments?.currcode },
                                                { label: "External Ref No", value: selectedPayment?.loanpayments?.externalrefno },
                                                { label: "Late Fees Only", value: selectedPayment?.loanpayments?.latefeesonly === "1" ? "Yes" : "No" },
                                                { label: "Lock Flag", value: selectedPayment?.loanpayments?.lockflag === "1" ? "Locked" : "Unlocked" },
                                                { label: "Last Reconcile Date", value: selectedPayment?.loanpayments?.lastreconciledate || "N/A" },
                                                { label: "Error Message", value: selectedPayment?.loanpayments?.errormsg || "N/A" }
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value || "N/A"}</Box>
                                                </Box>
                                            ))}
                                        </Box>

                                        <Box minWidth="300px" flex={1}>
                                            {[ 
                                                { label: "Payment Amount", value: selectedPayment?.loanpayments?.paymentamount },
                                                { label: "Amount Applied", value: selectedPayment?.loanpayments?.amountapplied },
                                                { label: "Residual Amount", value: selectedPayment?.loanpayments?.residualamount },
                                                { label: "Principal Amount Applied", value: selectedPayment?.loanpayments?.principleamountapplied },
                                                { label: "Fees Amount Applied", value: selectedPayment?.loanpayments?.feesamountapplied },
                                                { label: "Late Fees Amount Applied", value: selectedPayment?.loanpayments?.latefeesamountapplied },
                                                { label: "Hash Payment Amount", value: selectedPayment?.loanpayments?.hashpaymentamount },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">
                                                        {value ? Number(value).toLocaleString() : "N/A"}
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog> */}
            
        </Box>
    )

}

export default GroupLoansListPayments;
